module.exports = __webpack_public_path__ + "static/cubino-9069fce66df62d19491f83389ebe4f49.jpg";